export default __webpack_public_path__ + "static/media/roboto-v20-cyrillic_latin-700.e8f864e2.woff";